import React from 'react';

const usePrevious = <T>(newValue: T) => {
  const previousRef = React.useRef<T>();

  React.useEffect(() => {
    previousRef.current = newValue;
  });

  return previousRef.current;
};

export default usePrevious;
